/* ============================================================
   No Dirt Golf — DYO Product Customizer
   Golf Towel edition — Canvas 600×400
   ============================================================ */
(function () {
  'use strict';

  /* ----------------------------------------------------------
     Wait for DOM
  ---------------------------------------------------------- */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  function init() {
    var cfg = window.DYOConfig;
    if (!cfg) return; // not on a DYO page

    /* --------------------------------------------------------
       Constants
    -------------------------------------------------------- */
    var CW = 600;
    var CH = 400;
    var MIN_LOGO_PX = 24;
    var HANDLE_SIZE = 9; // half-size of corner handle square

    /* --------------------------------------------------------
       Print zone (percentage-based, resolved to pixels)
    -------------------------------------------------------- */
    var PZ = {
      x: Math.round(cfg.printZone.xPct * CW),
      y: Math.round(cfg.printZone.yPct * CH),
      w: Math.round(cfg.printZone.wPct * CW),
      h: Math.round(cfg.printZone.hPct * CH),
    };

    /* --------------------------------------------------------
       State
    -------------------------------------------------------- */
    var logo = {
      img: null,
      x: PZ.x + PZ.w / 2 - 60,
      y: PZ.y + PZ.h / 2 - 60,
      w: 120,
      h: 120,
      loaded: false,
    };
    var logoConfirmed = false;
    var propLogoUrl = '';
    var propPreviewUrl = '';
    var currentVariantPrice = 0; // in cents
    var qty = 1;
    var uploadState = 'idle'; // idle | uploading | done | error
    var productImg = null;
    var productImgLoaded = false;

    // Drag/resize state
    var drag = {
      active: false,
      mode: 'move', // 'move' | 'nw' | 'ne' | 'sw' | 'se'
      startX: 0,
      startY: 0,
      startLogoX: 0,
      startLogoY: 0,
      startLogoW: 0,
      startLogoH: 0,
    };

    /* --------------------------------------------------------
       DOM refs
    -------------------------------------------------------- */
    var canvas    = document.getElementById('dyo-canvas');
    var ctx       = canvas ? canvas.getContext('2d') : null;

    var triggerBtn     = document.getElementById('dyo-trigger-btn');
    var dyoPanel       = document.getElementById('dyo-panel');
    var fileInput      = document.getElementById('dyo-file-input');
    var uploadBtn      = document.getElementById('dyo-upload-btn');
    var uploadIcon     = document.getElementById('dyo-upload-icon');
    var uploadLabel    = document.getElementById('dyo-upload-label');
    var confirmArea    = document.getElementById('dyo-confirm-area');
    var confirmBtn     = document.getElementById('dyo-confirm-btn');
    var repositionBtn  = document.getElementById('dyo-reposition-btn');
    var priceAmount    = document.getElementById('dyo-price-amount');
    var submitBtn      = document.getElementById('dyo-submit-btn');
    var submitNote     = document.getElementById('dyo-submit-note');
    var errorMsg       = document.getElementById('dyo-error-msg');
    var dyoForm        = document.getElementById('dyo-product-form');
    var variantIdInput = document.getElementById('dyo-variant-id');
    var qtyInput       = document.getElementById('dyo-qty-input');
    var qtyMinus       = document.getElementById('dyo-qty-minus');
    var qtyPlus        = document.getElementById('dyo-qty-plus');
    var propLogoUrlInput      = document.getElementById('prop-logo-url');
    var propPreviewUrlInput   = document.getElementById('prop-preview-url');
    var propLogoPositionInput = document.getElementById('prop-logo-position');

    if (!canvas || !ctx) return;

    /* --------------------------------------------------------
       Variant setup
    -------------------------------------------------------- */
    var variants = cfg.variants || [];
    var currentVariant = variants[0] || null;

    // Read initial variant from hidden input
    if (variantIdInput && variantIdInput.value) {
      var initialId = parseInt(variantIdInput.value, 10);
      for (var i = 0; i < variants.length; i++) {
        if (variants[i].id === initialId) {
          currentVariant = variants[i];
          break;
        }
      }
    }
    currentVariantPrice = currentVariant ? currentVariant.price : 0;

    /* --------------------------------------------------------
       Reveal button toggle
    -------------------------------------------------------- */
    if (triggerBtn && dyoPanel) {
      triggerBtn.addEventListener('click', function () {
        var isOpen = dyoPanel.classList.toggle('is-open');
        triggerBtn.classList.toggle('is-active', isOpen);
        triggerBtn.setAttribute('aria-expanded', String(isOpen));
        dyoPanel.setAttribute('aria-hidden', String(!isOpen));
        if (isOpen) {
          setTimeout(function () {
            dyoPanel.scrollIntoView({ behavior: 'smooth', block: 'start' });
          }, 100);
        }
      });
    }

    /* --------------------------------------------------------
       Product image load
    -------------------------------------------------------- */
    if (cfg.productImage) {
      var pImg = new Image();
      pImg.crossOrigin = 'anonymous';
      pImg.onload = function () {
        productImg = pImg;
        productImgLoaded = true;
        drawCanvas();
      };
      pImg.onerror = function () {
        productImgLoaded = false;
        drawCanvas();
      };
      pImg.src = cfg.productImage;
    }

    /* --------------------------------------------------------
       drawCanvas
    -------------------------------------------------------- */
    function drawCanvas() {
      ctx.clearRect(0, 0, CW, CH);

      // --- Background ---
      if (productImgLoaded && productImg) {
        drawCoverImage(productImg);
      } else {
        // Light green towel background
        ctx.fillStyle = '#eef6e6';
        ctx.fillRect(0, 0, CW, CH);

        // Subtle microfiber texture lines
        ctx.save();
        ctx.strokeStyle = 'rgba(58,106,32,0.06)';
        ctx.lineWidth = 1;
        var lineCount = 20;
        var lineSpacing = CH / lineCount;
        for (var li = 0; li <= lineCount; li++) {
          var ly = Math.round(li * lineSpacing);
          ctx.beginPath();
          ctx.moveTo(0, ly);
          ctx.lineTo(CW, ly);
          ctx.stroke();
        }
        ctx.restore();

        // Subtle towel border/shadow
        ctx.save();
        ctx.strokeStyle = 'rgba(26,46,26,0.1)';
        ctx.lineWidth = 3;
        ctx.strokeRect(1.5, 1.5, CW - 3, CH - 3);
        ctx.restore();
      }

      // --- Dark scrim outside print zone (even-odd rule) ---
      ctx.save();
      ctx.fillStyle = 'rgba(0,0,0,0.3)';
      ctx.beginPath();
      // outer rect (canvas)
      ctx.rect(0, 0, CW, CH);
      // inner rect (print zone) — wound in opposite direction for evenodd
      ctx.rect(PZ.x, PZ.y, PZ.w, PZ.h);
      ctx.fill('evenodd');
      ctx.restore();

      // --- Print zone border ---
      ctx.save();
      ctx.strokeStyle = 'rgba(58,106,32,0.85)';
      ctx.lineWidth = 1.5;
      ctx.setLineDash([6, 4]);
      ctx.strokeRect(PZ.x, PZ.y, PZ.w, PZ.h);
      ctx.setLineDash([]);
      ctx.restore();

      // --- "Your logo here" placeholder ---
      if (!logo.loaded) {
        ctx.save();
        ctx.fillStyle = 'rgba(58,106,32,0.55)';
        ctx.font = '500 13px Figtree, sans-serif';
        ctx.textAlign = 'center';
        ctx.textBaseline = 'middle';
        ctx.fillText('Your logo here', PZ.x + PZ.w / 2, PZ.y + PZ.h / 2);
        ctx.restore();
      }

      // --- Logo image ---
      if (logo.loaded && logo.img) {
        ctx.save();
        // Clip to print zone
        ctx.beginPath();
        ctx.rect(PZ.x, PZ.y, PZ.w, PZ.h);
        ctx.clip();
        ctx.drawImage(logo.img, logo.x, logo.y, logo.w, logo.h);
        ctx.restore();

        // Resize handles (shown when not confirmed)
        if (!logoConfirmed) {
          drawHandles();
        }
      }

    }

    /* --------------------------------------------------------
       Draw cover-fit product image
    -------------------------------------------------------- */
    function drawCoverImage(img) {
      var imgW = img.naturalWidth;
      var imgH = img.naturalHeight;
      var scaleX = CW / imgW;
      var scaleY = CH / imgH;
      var scale = Math.max(scaleX, scaleY);
      var drawW = imgW * scale;
      var drawH = imgH * scale;
      var drawX = (CW - drawW) / 2;
      var drawY = (CH - drawH) / 2;
      ctx.drawImage(img, drawX, drawY, drawW, drawH);
    }

    /* --------------------------------------------------------
       Draw corner resize handles
    -------------------------------------------------------- */
    function drawHandles() {
      var corners = getCorners();
      ctx.save();
      ctx.fillStyle = '#3a6a20';
      for (var k in corners) {
        if (!corners.hasOwnProperty(k)) continue;
        var c = corners[k];
        ctx.fillRect(c.x - HANDLE_SIZE / 2, c.y - HANDLE_SIZE / 2, HANDLE_SIZE, HANDLE_SIZE);
      }
      ctx.restore();
    }

    /* --------------------------------------------------------
       Utility: rounded rect path
    -------------------------------------------------------- */
    function roundRect(c, x, y, w, h, r) {
      c.beginPath();
      c.moveTo(x + r, y);
      c.lineTo(x + w - r, y);
      c.quadraticCurveTo(x + w, y, x + w, y + r);
      c.lineTo(x + w, y + h - r);
      c.quadraticCurveTo(x + w, y + h, x + w - r, y + h);
      c.lineTo(x + r, y + h);
      c.quadraticCurveTo(x, y + h, x, y + h - r);
      c.lineTo(x, y + r);
      c.quadraticCurveTo(x, y, x + r, y);
      c.closePath();
    }

    /* --------------------------------------------------------
       Corner coordinates
    -------------------------------------------------------- */
    function getCorners() {
      return {
        nw: { x: logo.x,            y: logo.y },
        ne: { x: logo.x + logo.w,   y: logo.y },
        sw: { x: logo.x,            y: logo.y + logo.h },
        se: { x: logo.x + logo.w,   y: logo.y + logo.h },
      };
    }

    /* --------------------------------------------------------
       Hit test helpers
    -------------------------------------------------------- */
    function hitHandle(mx, my) {
      if (!logo.loaded || logoConfirmed) return null;
      var corners = getCorners();
      var hs = HANDLE_SIZE;
      for (var k in corners) {
        if (!corners.hasOwnProperty(k)) continue;
        var c = corners[k];
        if (mx >= c.x - hs && mx <= c.x + hs && my >= c.y - hs && my <= c.y + hs) {
          return k;
        }
      }
      return null;
    }

    function hitLogo(mx, my) {
      if (!logo.loaded || logoConfirmed) return false;
      return mx >= logo.x && mx <= logo.x + logo.w &&
             my >= logo.y && my <= logo.y + logo.h;
    }

    /* --------------------------------------------------------
       Canvas coordinate mapping
    -------------------------------------------------------- */
    function canvasCoords(e) {
      var rect = canvas.getBoundingClientRect();
      var scaleX = CW / rect.width;
      var scaleY = CH / rect.height;
      var src = e.touches ? e.touches[0] : e;
      return {
        x: (src.clientX - rect.left) * scaleX,
        y: (src.clientY - rect.top)  * scaleY,
      };
    }

    /* --------------------------------------------------------
       Constrain logo inside print zone
    -------------------------------------------------------- */
    function constrainLogo() {
      logo.x = Math.max(PZ.x, Math.min(PZ.x + PZ.w - logo.w, logo.x));
      logo.y = Math.max(PZ.y, Math.min(PZ.y + PZ.h - logo.h, logo.y));
    }

    /* --------------------------------------------------------
       Cursor update
    -------------------------------------------------------- */
    function updateCursor(mx, my) {
      var h = hitHandle(mx, my);
      if (h === 'nw' || h === 'se') {
        canvas.className = 'dyo-cursor-nwse';
      } else if (h === 'ne' || h === 'sw') {
        canvas.className = 'dyo-cursor-nesw';
      } else if (hitLogo(mx, my)) {
        canvas.className = 'dyo-cursor-grab';
      } else {
        canvas.className = '';
      }
    }

    /* --------------------------------------------------------
       Mouse / touch events on canvas
    -------------------------------------------------------- */
    function onPointerDown(e) {
      if (!logo.loaded || logoConfirmed) return;
      var pt = canvasCoords(e);
      var handle = hitHandle(pt.x, pt.y);
      if (handle) {
        drag.active = true;
        drag.mode = handle;
        drag.startX = pt.x;
        drag.startY = pt.y;
        drag.startLogoX = logo.x;
        drag.startLogoY = logo.y;
        drag.startLogoW = logo.w;
        drag.startLogoH = logo.h;
        canvas.className = 'dyo-cursor-grabbing';
        e.preventDefault();
      } else if (hitLogo(pt.x, pt.y)) {
        drag.active = true;
        drag.mode = 'move';
        drag.startX = pt.x;
        drag.startY = pt.y;
        drag.startLogoX = logo.x;
        drag.startLogoY = logo.y;
        canvas.className = 'dyo-cursor-grabbing';
        e.preventDefault();
      }
    }

    function onPointerMove(e) {
      if (!drag.active) {
        var pt2 = canvasCoords(e);
        updateCursor(pt2.x, pt2.y);
        return;
      }
      e.preventDefault();
      var pt = canvasCoords(e);
      var dx = pt.x - drag.startX;
      var dy = pt.y - drag.startY;

      if (drag.mode === 'move') {
        logo.x = drag.startLogoX + dx;
        logo.y = drag.startLogoY + dy;
        constrainLogo();
      } else {
        // Proportional resize from the dragged corner
        var aspect = drag.startLogoW / drag.startLogoH;
        var newW, newH;

        if (drag.mode === 'se') {
          newW = Math.max(MIN_LOGO_PX, drag.startLogoW + dx);
          newH = newW / aspect;
          logo.w = newW;
          logo.h = newH;
        } else if (drag.mode === 'sw') {
          newW = Math.max(MIN_LOGO_PX, drag.startLogoW - dx);
          newH = newW / aspect;
          logo.x = drag.startLogoX + drag.startLogoW - newW;
          logo.w = newW;
          logo.h = newH;
        } else if (drag.mode === 'ne') {
          newW = Math.max(MIN_LOGO_PX, drag.startLogoW + dx);
          newH = newW / aspect;
          logo.y = drag.startLogoY + drag.startLogoH - newH;
          logo.w = newW;
          logo.h = newH;
        } else if (drag.mode === 'nw') {
          newW = Math.max(MIN_LOGO_PX, drag.startLogoW - dx);
          newH = newW / aspect;
          logo.x = drag.startLogoX + drag.startLogoW - newW;
          logo.y = drag.startLogoY + drag.startLogoH - newH;
          logo.w = newW;
          logo.h = newH;
        }

        // Constrain size to print zone
        if (logo.w > PZ.w) { logo.w = PZ.w; logo.h = PZ.w / aspect; }
        if (logo.h > PZ.h) { logo.h = PZ.h; logo.w = PZ.h * aspect; }
        constrainLogo();
      }
      drawCanvas();
    }

    function onPointerUp(e) {
      if (!drag.active) return;
      drag.active = false;
      var pt = canvasCoords(e);
      updateCursor(pt.x, pt.y);
      drawCanvas();
    }

    canvas.addEventListener('mousedown', onPointerDown);
    canvas.addEventListener('mousemove', onPointerMove);
    canvas.addEventListener('mouseup',   onPointerUp);
    canvas.addEventListener('mouseleave', function (e) {
      if (drag.active) onPointerUp(e);
    });

    canvas.addEventListener('touchstart', onPointerDown, { passive: false });
    canvas.addEventListener('touchmove',  onPointerMove, { passive: false });
    canvas.addEventListener('touchend',   onPointerUp);

    /* --------------------------------------------------------
       Price display
    -------------------------------------------------------- */
    function updatePriceDisplay() {
      if (!priceAmount) return;
      priceAmount.textContent = formatMoney(currentVariantPrice, cfg.money_format);
    }

    /* --------------------------------------------------------
       formatMoney
    -------------------------------------------------------- */
    function formatMoney(cents, format) {
      var fmt = format || '${{amount}}';
      var amount = (cents / 100).toFixed(2);
      var amountNoDec = Math.floor(cents / 100).toString();
      var amountWithComma = formatWithComma(amount);
      var amountNoDecWithComma = formatWithComma(amountNoDec);

      return fmt
        .replace('{{amount_with_comma_separator}}', amountWithComma)
        .replace('{{amount_no_decimals_with_comma_separator}}', amountNoDecWithComma)
        .replace('{{amount_no_decimals}}', amountNoDec)
        .replace('{{amount}}', amount);
    }

    function formatWithComma(str) {
      var parts = str.split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      return parts.join('.');
    }

    /* --------------------------------------------------------
       Variant change (radio inputs outside the DYO form)
    -------------------------------------------------------- */
    document.addEventListener('change', function (e) {
      var radio = e.target;
      if (radio && radio.type === 'radio' && radio.name && radio.name.indexOf('options') !== -1) {
        // Re-read from currently selected variant
        syncVariantFromPage();
      }
    });

    // Also watch Shopify variant:change event
    document.addEventListener('variant:change', function (e) {
      var detail = e.detail;
      if (detail && detail.variant) {
        currentVariant = detail.variant;
        currentVariantPrice = currentVariant.price;
        if (variantIdInput) variantIdInput.value = currentVariant.id;
        updatePriceDisplay();
      }
    });

    function syncVariantFromPage() {
      // Try to find selected variant from page's variant picker
      var selectedId = getSelectedVariantIdFromPage();
      if (!selectedId) return;
      for (var i = 0; i < variants.length; i++) {
        if (variants[i].id === selectedId) {
          currentVariant = variants[i];
          currentVariantPrice = currentVariant.price;
          if (variantIdInput) variantIdInput.value = currentVariant.id;
          updatePriceDisplay();
          break;
        }
      }
    }

    function getSelectedVariantIdFromPage() {
      // Dawn uses a native <select> or a hidden input with variant id
      var sel = document.querySelector('select[name="id"]');
      if (sel) return parseInt(sel.value, 10);
      var hidden = document.querySelector('input[name="id"]');
      if (hidden) return parseInt(hidden.value, 10);
      return null;
    }

    /* --------------------------------------------------------
       Quantity controls
    -------------------------------------------------------- */
    if (qtyMinus) {
      qtyMinus.addEventListener('click', function () {
        qty = Math.max(1, qty - 1);
        if (qtyInput) qtyInput.value = qty;
        var display = document.getElementById('dyo-qty-display');
        if (display) display.value = qty;
      });
    }

    if (qtyPlus) {
      qtyPlus.addEventListener('click', function () {
        qty = qty + 1;
        if (qtyInput) qtyInput.value = qty;
        var display = document.getElementById('dyo-qty-display');
        if (display) display.value = qty;
      });
    }

    /* --------------------------------------------------------
       File upload
    -------------------------------------------------------- */
    if (uploadBtn && fileInput) {
      uploadBtn.addEventListener('click', function () {
        fileInput.click();
      });

      fileInput.addEventListener('change', function () {
        var file = this.files && this.files[0];
        if (!file) return;

        // Validate type
        var allowedTypes = ['image/png', 'image/jpeg', 'image/svg+xml', 'image/webp'];
        if (allowedTypes.indexOf(file.type) === -1) {
          showError('Please upload a PNG, JPG, SVG, or WebP file.');
          return;
        }

        hideError();
        setUploadState('uploading');

        // Load locally for preview
        var reader = new FileReader();
        reader.onload = function (ev) {
          var img = new Image();
          img.onload = function () {
            logo.img = img;
            logo.loaded = true;

            // Center logo in print zone at a reasonable default size
            var maxW = PZ.w * 0.6;
            var maxH = PZ.h * 0.6;
            var scale = Math.min(maxW / img.naturalWidth, maxH / img.naturalHeight, 1);
            logo.w = Math.max(MIN_LOGO_PX, img.naturalWidth * scale);
            logo.h = Math.max(MIN_LOGO_PX, img.naturalHeight * scale);
            logo.x = PZ.x + (PZ.w - logo.w) / 2;
            logo.y = PZ.y + (PZ.h - logo.h) / 2;

            drawCanvas();
            showConfirmArea();

            // Upload to Cloudinary (async — preview is already shown)
            uploadToCloudinary(file);
          };
          img.onerror = function () {
            setUploadState('error');
            showError('Could not read image. Please try a different file.');
          };
          img.src = ev.target.result;
        };
        reader.onerror = function () {
          setUploadState('error');
          showError('Failed to read file. Please try again.');
        };
        reader.readAsDataURL(file);
      });
    }

    /* --------------------------------------------------------
       Cloudinary upload
    -------------------------------------------------------- */
    function uploadToCloudinary(file) {
      if (!cfg.cloudName || !cfg.uploadPreset) {
        // No Cloudinary config — just proceed without a hosted URL
        setUploadState('done');
        propLogoUrl = '';
        return;
      }

      var formData = new FormData();
      formData.append('file', file);
      formData.append('upload_preset', cfg.uploadPreset);

      fetch('https://api.cloudinary.com/v1_1/' + cfg.cloudName + '/image/upload', {
        method: 'POST',
        body: formData,
      })
        .then(function (res) {
          if (!res.ok) throw new Error('Upload failed: ' + res.status);
          return res.json();
        })
        .then(function (data) {
          propLogoUrl = data.secure_url || '';
          if (propLogoUrlInput) propLogoUrlInput.value = propLogoUrl;
          setUploadState('done');
        })
        .catch(function (err) {
          console.warn('[DYO] Cloudinary upload error:', err);
          setUploadState('error');
          showError('Logo upload failed. You can still confirm placement and we will process your design manually.');
          // Don't block the user — let them continue
          setUploadState('done');
        });
    }

    /* --------------------------------------------------------
       Preview upload (canvas blob → Cloudinary)
    -------------------------------------------------------- */
    function uploadPreviewCanvas() {
      if (!cfg.cloudName || !cfg.uploadPreset) return;

      canvas.toBlob(function (blob) {
        if (!blob) return;
        var formData = new FormData();
        formData.append('file', blob, 'dyo-preview.jpg');
        formData.append('upload_preset', cfg.uploadPreset);

        fetch('https://api.cloudinary.com/v1_1/' + cfg.cloudName + '/image/upload', {
          method: 'POST',
          body: formData,
        })
          .then(function (res) { return res.json(); })
          .then(function (data) {
            propPreviewUrl = data.secure_url || '';
            if (propPreviewUrlInput) propPreviewUrlInput.value = propPreviewUrl;
          })
          .catch(function (err) {
            console.warn('[DYO] Preview upload error:', err);
          });
      }, 'image/jpeg', 0.85);
    }

    /* --------------------------------------------------------
       Upload UI states
    -------------------------------------------------------- */
    function setUploadState(state) {
      uploadState = state;
      if (!uploadIcon || !uploadLabel) return;

      uploadIcon.className = 'dyo-upload-btn__icon';

      switch (state) {
        case 'uploading':
          uploadIcon.className = 'dyo-upload-btn__icon is-spinning';
          uploadIcon.innerHTML = '';
          uploadLabel.textContent = 'Uploading…';
          break;
        case 'done':
          uploadIcon.innerHTML = svgCheck();
          uploadLabel.textContent = 'Logo Uploaded';
          break;
        case 'error':
          uploadIcon.innerHTML = svgX();
          uploadLabel.textContent = 'Upload Failed — Retry?';
          break;
        default: // idle
          uploadIcon.innerHTML = svgUpload();
          uploadLabel.textContent = 'Upload Your Logo';
          break;
      }
    }

    function svgUpload() {
      return '<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" aria-hidden="true"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><polyline points="17 8 12 3 7 8"/><line x1="12" y1="3" x2="12" y2="15"/></svg>';
    }

    function svgCheck() {
      return '<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#3a6a20" stroke-width="2" aria-hidden="true"><polyline points="20 6 9 17 4 12"/></svg>';
    }

    function svgX() {
      return '<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#c0392b" stroke-width="2" aria-hidden="true"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>';
    }

    /* --------------------------------------------------------
       Show / hide confirm area
    -------------------------------------------------------- */
    function showConfirmArea() {
      if (confirmArea) confirmArea.hidden = false;
      if (repositionBtn) repositionBtn.hidden = true;
    }

    function hideConfirmArea() {
      if (confirmArea) confirmArea.hidden = true;
    }

    /* --------------------------------------------------------
       Confirm / reposition
    -------------------------------------------------------- */
    if (confirmBtn) {
      confirmBtn.addEventListener('click', function () {
        logoConfirmed = true;
        hideConfirmArea();
        if (repositionBtn) repositionBtn.hidden = false;
        enableSubmit();

        // Store logo position
        storeLogoPosition();

        // Upload preview
        uploadPreviewCanvas();

        drawCanvas();
      });
    }

    if (repositionBtn) {
      repositionBtn.addEventListener('click', function () {
        logoConfirmed = false;
        repositionBtn.hidden = true;
        showConfirmArea();
        disableSubmit('Confirm logo placement to continue');
        drawCanvas();
      });
    }

    function storeLogoPosition() {
      if (!propLogoPositionInput) return;
      var pos = {
        x: logo.x,
        y: logo.y,
        w: logo.w,
        h: logo.h,
        canvasW: CW,
        canvasH: CH,
        xPct: logo.x / CW,
        yPct: logo.y / CH,
        wPct: logo.w / CW,
        hPct: logo.h / CH,
      };
      propLogoPositionInput.value = JSON.stringify(pos);
    }

    function enableSubmit() {
      if (!submitBtn) return;
      submitBtn.disabled = false;
      submitBtn.setAttribute('aria-disabled', 'false');
      if (submitNote) submitNote.textContent = '';
    }

    function disableSubmit(msg) {
      if (!submitBtn) return;
      submitBtn.disabled = true;
      submitBtn.setAttribute('aria-disabled', 'true');
      if (submitNote && msg) submitNote.textContent = msg;
    }

    /* --------------------------------------------------------
       Error helpers
    -------------------------------------------------------- */
    function showError(msg) {
      if (!errorMsg) return;
      errorMsg.textContent = msg;
      errorMsg.hidden = false;
    }

    function hideError() {
      if (!errorMsg) return;
      errorMsg.hidden = true;
      errorMsg.textContent = '';
    }

    /* --------------------------------------------------------
       Cart submission
    -------------------------------------------------------- */
    if (dyoForm) {
      dyoForm.addEventListener('submit', function (e) {
        e.preventDefault();
        hideError();

        if (!logoConfirmed) {
          showError('Please upload your logo and confirm placement before adding to cart.');
          return;
        }

        var variantId = variantIdInput ? parseInt(variantIdInput.value, 10) : null;
        if (!variantId) {
          showError('Please select a product variant.');
          return;
        }

        // Collect properties
        var properties = {
          'Customized': 'Yes',
        };
        if (propLogoUrl) properties['_logo_url'] = propLogoUrl;
        if (propPreviewUrl) properties['_preview_url'] = propPreviewUrl;
        if (propLogoPositionInput && propLogoPositionInput.value) {
          properties['_logo_position'] = propLogoPositionInput.value;
        }
        setSubmitting(true);
        addSingleToCart(variantId, properties);
      });
    }

    function addSingleToCart(variantId, properties) {
      var body = {
        id: variantId,
        quantity: qty,
        properties: properties,
      };
      cartAdd(JSON.stringify(body))
        .then(function () {
          onCartSuccess();
        })
        .catch(function (err) {
          setSubmitting(false);
          showError('Could not add to cart: ' + err.message);
        });
    }

    function cartAdd(bodyString) {
      return fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: bodyString,
      }).then(function (res) {
        if (!res.ok) {
          return res.json().then(function (data) {
            throw new Error(data.description || data.message || 'Add to cart failed');
          });
        }
        return res.json();
      });
    }

    function onCartSuccess() {
      setSubmitting(false);
      // Try Shopify cart drawer refresh event
      document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));

      // Also dispatch for Dawn's cart drawer
      var event = new CustomEvent('dispatch:cart-drawer:open', { bubbles: true });
      document.documentElement.dispatchEvent(event);

      // Fallback: reload after brief delay if no cart drawer responded
      var reloaded = false;
      document.addEventListener('cart:refreshed', function handler() {
        reloaded = true;
        document.removeEventListener('cart:refreshed', handler);
      }, { once: true });

      setTimeout(function () {
        if (!reloaded) {
          window.location.href = '/cart';
        }
      }, 1200);
    }

    function setSubmitting(isSubmitting) {
      if (!submitBtn) return;
      var submitText = document.getElementById('dyo-submit-text');
      if (isSubmitting) {
        submitBtn.disabled = true;
        if (submitText) submitText.textContent = 'Adding to Cart…';
      } else {
        submitBtn.disabled = false;
        if (submitText) submitText.textContent = 'Add Customized Version to Cart';
      }
    }

    /* --------------------------------------------------------
       Initial draw
    -------------------------------------------------------- */
    drawCanvas();
    updatePriceDisplay();
    disableSubmit('Upload your logo and confirm placement to continue');
  }

})();
